import { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import CurrencyRateShareModal from 'components/CurrencyRateShareModal';
import Icon from 'components/commons/Icon';

import { Button } from './styles';

const ShareRateButton = ({ currencyData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button onClick={handleOpenModal}>
        <Icon name="shareIcon" />
        <FormattedMessage id="share" />
      </Button>

      {isModalOpen && (
        <CurrencyRateShareModal
          data={currencyData}
          onClose={handleCloseModal}
          isModalOpen={isModalOpen}
        />
      )}
    </>
  );
};

ShareRateButton.propTypes = {
  currencyData: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default ShareRateButton;
